import { render } from "./MyOrdersView.vue?vue&type=template&id=4eb25e9e&scoped=true"
import script from "./MyOrdersView.vue?vue&type=script&lang=js"
export * from "./MyOrdersView.vue?vue&type=script&lang=js"

import "./MyOrdersView.vue?vue&type=style&index=0&id=4eb25e9e&scoped=true&lang=css"
import "./MyOrdersView.vue?vue&type=style&index=1&id=4eb25e9e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eb25e9e"]])

export default __exports__